export const JOBDOM_CATEGORIES = [
  {
    id: 'A',
    text: '전체',
  },
  {
    id: 'U',
    text: '강추',
  },
  {
    id: 'D',
    text: '비추',
  },
  {
    id: 'E',
    text: '취업고민',
  },
  {
    id: 'S',
    text: '연봉고민',
  },
];
